<div class="navbar-expand footer" id="idfooter">
  <div class="footer-copyright text-center py-3 footer-min"><b> © {{ date }} Copyright: </b>
    <a href="https://www.lafabril.com.ec/en/home/"> www.lafabril.com.ec</a>
  </div>
</div>
